import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles, { scrollableTableContainer } from "component/utils/DatatableStyles";

const paginationOptions = {
  rowsPerPageText: "Show Per Page:",
  rangeSeparatorText: "dari",
};

const LovMasterCoAFrom = ({ show, data, onClose, onSelect }) => {
  const [search, setSearch] = useState("");

  if (!show) return null;

  // Tambahkan ID otomatis
  const formattedData = data.map((item, index) => ({
    id: index + 1,
    ...item,
  }));

  // Filter berdasarkan kolom tertentu
  const filteredData = formattedData.filter((item) =>
    [
      item?.group_account_code,
      item?.group_account_desc,
      item?.group_account_div,
      item?.group_account_dep,
    ].some((field) =>
      field?.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  const columns = [
    {
      name: "No",
      selector: (row) => row.id,
      minWidth: "50px",
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      sortable: true,
    },
    {
      name: "Kode",
      selector: (row) => row.group_account_code,
      sortable: true,
      minWidth: "80px",
      style: { display: "flex", justifyContent: "center", alignItems: "center" },
    },
    {
      name: "Deskripsi",
      selector: (row) => row.group_account_desc,
      sortable: true,
      minWidth: "250px",
    },
    {
      name: "Div",
      selector: (row) => row.group_account_div,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Dep",
      selector: (row) => row.group_account_dep,
      sortable: true,
      minWidth: "200px",
      wrap: true,
      style: { display: "flex" },
    },
    {
      name: "Aksi",
      cell: (row) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => onSelect(row)}
        >
          Pilih
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: "70px",
    },
  ];

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Pilih Data</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="d-flex justify-content-start align-items-center mb-2">
              <input
                type="text"
                placeholder="Search..."
                className="form-control"
                style={{ maxWidth: "250px" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div style={scrollableTableContainer}>
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                customStyles={DatatableStyles}
                paginationPerPage={5}
                paginationRowsPerPageOptions={[5, 10, 25]}
                paginationComponentOptions={paginationOptions}
                responsive={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LovMasterCoAFrom;
